import { render } from "./ResultFileStatusDetailsTestReports.vue?vue&type=template&id=5b4fb225"
import script from "./ResultFileStatusDetailsTestReports.vue?vue&type=script&lang=js"
export * from "./ResultFileStatusDetailsTestReports.vue?vue&type=script&lang=js"

import "./ResultFileStatusDetailsTestReports.vue?vue&type=style&index=0&id=5b4fb225&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/resultFiles/ResultFileStatusDetailsTestReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4fb225"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4fb225', __exports__)) {
    console.log('reload')
    api.reload('5b4fb225', __exports__)
  }
  
  module.hot.accept("./ResultFileStatusDetailsTestReports.vue?vue&type=template&id=5b4fb225", () => {
    console.log('re-render')
    api.rerender('5b4fb225', render)
  })

}


export default __exports__